<template>
  <div id="app">
    <transition name="fade">
    <a-loading v-if="loading"/>
    </transition>
    <div id="nav">
      <a-navigation />
    </div>
    <main v-if="!loading">
      <router-view />
    </main>
    <a-footer />
  </div>
</template>
<script>
import aLoading from '@/components/a-loading'
import aNavigation from '@/components/a-navigation'
import aFooter from '@/components/a-footer'
import { mapGetters } from 'vuex'

export default {
  data(){
    return {
      loading: true
    }
  },
  components: {
    aNavigation,
    aFooter,
    aLoading
  },
  computed: {
    ...mapGetters({
      proposal: 'getProposal'
    })
  },
  watch: {
    '$route.params.id': function(val) {
      if (val && !this.proposal) {
        fetch(`/api/${val}`)
        .then(res => res.json())
        .then(res => {
            this.$store.commit('setProposal', res)
            this.loading = false;
            localStorage.setItem('proposalId', res.Proposal.ProposalId);
        })
        .catch(error => {
          this.$router.push('/404')
          this.loading = false;
        })
      } else {
        this.loading = false
      }

    }
  },
  mounted(){
    this.loading = this.$route.name !== 'Home' && this.$route.name !== '404'
  }
}
</script>
<style lang="scss">
@import url(https://assets.assurity.com/fonts/amsi-pro.css);
@import url(https://assets.assurity.com/fonts/garamond.css);

body {
  margin: 0;
}
* * {
  box-sizing: border-box;
  color: $gray;
}
.body-wrapper {
	max-width: 1580px;
	margin: auto;
	padding: 100px;
  padding-top: 0px;
	@media(max-width: 800px) {
    padding: 30px;
	}
}
p {
  line-height: 1.5;
}
.list .list-item {
  line-height: 1.5;
  padding-top: 10px;
  padding-bottom: 10px;
}
#app {
  font-family: 'Amsi Pro', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 100vw;
  overflow-x: hidden;
}
.fade-leave-active {
  transition: all .3s ease .3s;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}

// Screen Readers Only
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}
.table-card {
	padding: 20px;
	border: 1px solid lighten($lightgray, 20%);
	border-radius: 4px;
	margin: 20px auto;
}
.input-card {
	padding: 20px;
	border: 1px solid lighten($lightgray, 20%);
	border-radius: 4px;
	max-width: 780px;
	margin: 20px auto;
  padding-top: 40px;
}
.input-container {
	position: relative;
	margin-bottom: 20px;
	input {
		padding: 10px 20px;
		border-radius: 4px;
		margin: auto;
		font-size: 16px;
		border: 1px solid $gray;
		width: calc(50% - 5px);
		@media (max-width: 768px){
			width: 100%;
		}
	}
	label {
		position: absolute;
		top: -10px;
		left: 5px;
		background: #ffffff;
		padding: 0 5px;
		font-size: 14px;
		font-weight: bold;
		color: $navy;
	}
}
.radio-container {
	margin-bottom: 20px;
	display: flex;
	@media(max-width: 768px){
		flex-direction: column;
	}
	input {
		appearance: none;
		width: 0;
		height: 0;
		position: absolute;
	}
	label {
		padding: 10px 20px;
		text-align: center;
		width: 100%;
		border-radius: 4px;
		border: 1px solid $navy;
		display: inline-block;
		background: #ffffff;
		margin-top: 20px;
		&:not(:last-child) {
			margin-right: 10px;
		}
		@media(max-width: 768px){
    & {
        margin-top: 0;
      }
			&:not(:last-child) {
				margin-right: auto;
				margin-bottom: 10px;
			}
		}
	}
	input:checked + label {
		background: $navy;
		color: $white;
		}	
	}
</style>
